<!-- זהו קובץ ה-HTML של תבנית הסקלטון, לדוגמה: request-submission-methods-skeleton.html -->

<div class="container">
    <div class="mi-submission-methods row">
        <div class="  col-12 mi-panel-wrraper">
            <div class="mi-white-panel with-shadow">
                <div class="mi-choose-authority col-12">
                    <div class="mi-choose-authority-title">
                        <mc-bar-skeleton [widthBar]="'70%'" [heightBar]="'2.5rem'"></mc-bar-skeleton>
                    </div>
                    <br />

                    <div class="col-12 " style="width: 100%; margin-bottom: 20px;">
                        <mc-bar-skeleton [widthBar]="'100%'" [heightBar]="'3rem'"></mc-bar-skeleton>
                    </div>

                    <div class="mi-info col-md-12">
                        <mc-bar-skeleton [widthBar]="'90%'" [heightBar]="'2rem'"></mc-bar-skeleton>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="mi-request-submission-methods-navigation row">
        <div class="col-md-8 col-xs-12 col-xl-4 mc-mt-4">
            <mc-bar-skeleton [widthBar]="'100%'" [heightBar]="'3.5rem'"></mc-bar-skeleton>
        </div>
    </div>
</div>